module.exports = __webpack_public_path__ + "img/pintecBg.506ec369.png";